module.exports = __webpack_public_path__ + "img/layer-21@2x.481265db.png";